/**
 * Created by claudio iozzia on 22/06/2017.
 */
import {AcceptorOutputFn, andAcceptorSingle} from "../../../../models/acceptor/IAcceptor";
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ISingleOutput} from "../../../../models/ISpec";
import {Acceptor_DcDc_Buck} from "./dcdc_buck_acceptor";

export class Acceptor_DcDc_BuckBoost extends Acceptor_DcDc_Buck {

  constructor ( ledDcDc: boolean= false) {super(ledDcDc); }

  protected acceptSingle_Buck_Vout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    return  true;
  }

}


